<template>
  <div class="filter-col tw-w-fit tw-hidden lg:tw-block">
    <div class="filter-header px-2">
      <div class="filter-header-inner d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center py-2">
          <b-img :src="filterIconUrl"></b-img>
          <span class="font-weight-bold ml-2">FILTERS</span>
        </div>
        <div class="d-flex align-items-center">
          <ais-clear-refinements>
            <div slot-scope="{ canRefine, refine, createURL }">
              <a :href="createURL()" @click.prevent="refine" v-if="canRefine"
                 class="btn btn-link d-flex align-items-center p-0">
                <span class="mr-1">Clear</span>
                <b-img :src="filterCancelIconUrl"></b-img>
              </a>
            </div>
          </ais-clear-refinements>
        </div>
      </div>
    </div>

    <div class="filter-body px-2">
      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>TYPE <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>

          <ais-menu attribute="type" #default="{ items, canToggleShowMore, isShowingMore, toggleShowMore, refine, createURL}">
            <ul class="ais-RefinementList-list">
              <li v-for="item in items" :key="item.value">
                <label class="ais-RefinementList-label">
                  <a :href="createURL(item.value)"
                     @click.prevent="refine(item.value)">

                    <input type="checkbox"
                           :value="item.value"
                           :checked="item.isRefined"
                           style="pointer-events: none"
                           @change="refine(item.value)">

                    <span class="ais-RefinementList-labelText">
                            {{ item.label.capitalized() }}s
                          </span>

                    <b-badge variant="primary">{{ item.count }}</b-badge>
                  </a>
                </label>
              </li>
            </ul>
          </ais-menu>

        </template>
      </ais-panel>

      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>USAGE <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="usage" :transform-items="transformUsage"/>
        </template>
      </ais-panel>

      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>TYPES OF PEOPLE <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="premium" :transform-items="transformPremium"/>
        </template>
      </ais-panel>

      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>CATEGORY <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="categories"/>
        </template>
      </ais-panel>
      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>RACE <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="race"/>
        </template>
      </ais-panel>
      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>ETHNICITY <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="ethnicity"/>
        </template>
      </ais-panel>
      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>GENDER / ID <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="gender"/>
        </template>
      </ais-panel>
      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>AGE <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="ages"/>
        </template>
      </ais-panel>
      <ais-panel>
        <template #header="{ hasRefinements }">
          <p>NUMBER OF PEOPLE <span v-if="!hasRefinements">(no results)</span></p>
        </template>
        <template #default>
          <ais-refinement-list attribute="number_of_people"/>
        </template>
      </ais-panel>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'filterIconUrl',
    'filterCancelIconUrl'
  ],
  methods: {
    transformPremium(items) {
      return items.map(item => {
        return {
          ...item,
          label: item.label.toLowerCase() === 'true' ? 'Celebrities' : 'Everday People'
        };
      });
    },

    upcaseLabels(items) {
      return items.map(item => {
        return {
          ...item,
          label: item.label[0].toUpperCase() + item.label.slice(1)
        };
      });
    },

    transformUsage(items) {
      return items.map(item => {
        return {
          ...item,
          label: item.label.capitalized()
        };
      });
    },
  }
}
</script>